import React from 'react'
import Swal from 'sweetalert2'
import { Button } from 'primereact/button'
import { deleteData, postData } from '../../../actions/servicesHttp'
import PropTypes from 'prop-types'
import '../../../css/generals/sweetAlert.css'
import styles from '../../../css/Safeweb/SafeWeb.module.css'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function ModifyListSafe ({ data, reload }) {
  // console.log(props);
  const { t } = useTranslation('dataTableDemo')
  const navigate = useNavigate()

  async function moveList (type) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons
      .fire({
        title: t('modifyListSafe.message1'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('modifyListSafe.button1'),
        cancelButtonText: t('modifyListSafe.button2'),
        reverseButtons: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          await deleteData('safeweb/blackList', data.id, navigate)
          const json = {
            url: data.url,
            count: data.count,
            suspect: false
          }
          const responsePost = await postData(`safeweb/${type}`, json, navigate)

          if (responsePost.status === 200) {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: t('modifyListSafe.message2'),
              showConfirmButton: false,
              timer: 1500
            })
            reload()
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: t('modifyListSafe.message3'),
              showConfirmButton: false,
              timer: 1500
            })
          }

          reload()
        }
      })
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
      <Button
        className={`${styles.btnHover}`}
        style={{ marginRight: '1rem' }}
        aria-label="Cancel"
        onClick={() => moveList('whiteList')}
      >
        {t('modifyListSafe.button3')}
      </Button>
      <Button
        className={`${styles.btnHover}`}
        aria-label="Cancel"
        onClick={() => moveList('blackList')}
      >
        {t('modifyListSafe.button4')}
      </Button>
    </div>
  )
}

ModifyListSafe.propTypes = {
  data: PropTypes.object,
  reload: PropTypes.func
}
